module.exports = __webpack_public_path__ + "media/recipes/97-8b7ab52f.png";